import { isAxiosError } from 'axios';

export function useOtp<P extends unknown[] = never[]>(
    loader: (...params: P) => Promise<void>
) {
    const loading = ref(false);
    const tooManyTries = ref(false);
    const timer = ref(120);
    async function sendToken(...params: P) {
        loading.value = true;
        try {
            await loader(...params);
            timer.value = 120;
        } catch (ex) {
            const e = ex as any;
            if (e?.response?.data?.transientExceptionWaitTime) {
                timer.value = +e.response.data.transientExceptionWaitTime;
                return { ongoing: true };
            }
            if (isAxiosError(ex)) {
                if (ex.response?.status === 429) {
                    const errorText =
                        e.response.data.error ||
                        'خطایی در ارتباط با سرور رخ‌داد!';
                    swal({
                        title: errorText,
                        text: 'لطفاً مدتی بعد دوباره تلاش کنید.',
                        confirmButtonText: 'تایید',
                    });
                    tooManyTries.value = true;
                    return;
                }
            }
            const errorText =
                e.response?.data?.error || 'خطایی در ارتباط با سرور رخ‌داد!';
            swal({
                title: errorText,
                icon: 'error',
                text: 'لطفا دوباره تلاش کنید.',
                confirmButtonText: 'تایید',
            });
            throw new Error(errorText);
        } finally {
            loading.value = false;
        }
    }

    return {
        loading,
        timer,
        sendToken,
        tooManyTries,
    };
}
